import { defineComponent, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { TLayout } from '@tencent/web-vbui';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import TipsBottom from '@common/components/loan/TipsBottom.vue';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import { GetLoanConfigList } from '../../core/network/NodeAPI';
export default defineComponent({
    name: 'Entrance',
    components: {
        TLayout,
        TipsBottom,
    },
    setup() {
        const { setTitle, getLanguage, showModalError } = baseMixins();
        const entranceList = ref([]);
        // 多语言设置标题
        const { getT } = i18n;
        const $t = getT();
        setTitle($t('贷款'));
        const lang = getLanguage();
        const router = useRouter();
        const jumpToRightPage = async (brand) => {
            // const res = await accountCheck({
            //   needAutoLogin: true,
            //   loginReload: true,
            //   needActivateModal: true,
            //   needOpenModal: false,
            // });
            // if (res.code === RESULTCODE.LOGINRELOAD) {
            //   return;
            // }
            // if (res.code !== RESULTCODE.SUCCESS) {
            //   // 检测不成功 组件会走其他异常流程比如拉起开户 激活弹层
            //   if (res.code === RESULTCODE.NOACCOUNT) {
            //     return;
            //   }
            //   return;
            // }
            reportStatistics({
                evtName: `${brand}EntranceClick`,
                desc: `${brand === 'tesla' ? 'tesla' : '全量'}车主权益入口按钮点击`,
            });
            if (brand === 'tesla') {
                router.push('/teslaRightOverview');
            }
            else {
                router.push('/otherRightOverview');
            }
        };
        const formatParam = (p, lang) => {
            try {
                return JSON.parse(p)[0][lang];
            }
            catch (error) {
                return p;
            }
        };
        // 获取入口配置
        const getConfigInfo = async () => {
            const [data, err] = await to(GetLoanConfigList('right_entrance', 'right_home_conf'));
            if (err) {
                showModalError(err.message, err.code);
                return;
            }
            if (data?.content?.length) {
                entranceList.value = data.content
                    .map((item) => ({
                    brand: item.brand,
                    entranceImg: formatParam(item.entranceImg, lang),
                }))
                    .sort((a, b) => {
                    const brandMap = {
                        tesla: 0,
                        other: 1,
                    };
                    return Number(brandMap[a.brand]) - Number(brandMap[b.brand]);
                });
            }
        };
        onBeforeMount(async () => {
            spin.show();
            await getConfigInfo();
            spin.hide();
        });
        return {
            entranceList,
            lang,
            jumpToRightPage,
        };
    },
});
